import { CreateReportButton } from "@/components/CreateReportButton";
import { PageActions } from "@/components/PageActions";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LayoutDashboard, UserPlus, ClipboardList } from "lucide-react";
import CockpitRH from "./CockpitRH";
import Recrutement from "./Recrutement";
import AdminPersonnel from "./AdminPersonnel";
import { useRhFilters, RhFilterBar } from "@/components/rh/RhFilterBar";
import { RhQuickActions } from "@/components/rh/RhQuickActions";
import { RhFormModal } from "@/components/rh/RhForms";

// Navigation Support > RH : 3 espaces — Piloter · Recruter · Suivre la vie RH du collaborateur. Les tâches sont transversales (rattachées aux objets).
const SECTIONS = [
  { k: "cockpit", l: "Cockpit RH", icon: LayoutDashboard },
  { k: "recrutement", l: "Recrutement", icon: UserPlus },
  { k: "admin", l: "Administration du personnel", icon: ClipboardList },
];

export default function RHHub() {
  const [sp, setSp] = useSearchParams();
  const active = useMemo(() => (SECTIONS.find(s => s.k === sp.get("s")) || SECTIONS[0]).k, [sp]);
  const filters = useRhFilters();
  const [form, setForm] = useState(null); const [refreshKey, setRefreshKey] = useState(0);
  const navigate = src => { if (src?.kind === "tab") setSp({ s: src.id, ...(src.sub ? { sub: src.sub } : {}) }); else if (src?.kind === "recrutement") setSp({ s: "recrutement", open: src.id }); else setSp({ s: "admin", open: src?.id || "", kind: src?.kind || "" }); };
  return (
    <div className="space-y-4" data-testid="rh-hub-page">
      <div className="bg-white border border-slate-200 rounded-2xl p-1.5 flex gap-1 overflow-x-auto sticky top-0 z-20 shadow-sm items-center">
        {SECTIONS.map(s => <button key={s.k} onClick={() => setSp({ s: s.k })} data-testid={`rh-hub-tab-${s.k}`} className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold whitespace-nowrap transition ${active === s.k ? "bg-slate-900 text-white shadow-sm" : "text-slate-600 hover:bg-slate-100"}`}><s.icon className="w-4 h-4" /> {s.l}</button>)}
        <PageActions title="RH" testid="rhhub-actions"><CreateReportButton module="rh" /></PageActions>
      </div>
      {active === "cockpit" && <CockpitRH key={refreshKey} filters={filters} onOpenForm={setForm} onNavigate={navigate} />}
      {active !== "cockpit" && <><RhFilterBar meta={filters.meta} f={filters.f} setF={filters.setF} /><RhQuickActions onOpen={setForm} /></>}
      {active === "recrutement" && <Recrutement key={refreshKey} />}
      {active === "admin" && <AdminPersonnel key={refreshKey} />}
      {form && <RhFormModal kind={form} meta={filters.meta} onClose={() => setForm(null)} onDone={() => setRefreshKey(k => k + 1)} />}
    </div>
  );
}
